import { retentionsStatusLabels } from "helpers/retentionsDictionary";

export const RETENTION_OUTPUTS_LABELS = {
  title: "Salidas de Retenciones",
  headers: {
    customerName: "Cliente Mayorista",
    advanceDate: "Fecha Anticipo",
    userAR: "Usuario AR",
    userRequest: "Usuario Solicitante",
    userDelivery: "Usuario Entrega",
    amount: "Gasto",
    type: "Tipo",
    status: "Estado",
    description: "Descripción",
    actions: "Acciones",
  },
  status: retentionsStatusLabels,
  tooltips: {
    pdf: "PDF de Retenciones",
    accept: "Aceptar",
    reject: "Rechazar",
    deliver: "Entregar",
    delete: "Eliminar",
    uploadEvidence: "Adjuntar evidencia",
    viewEvidence: "Ver evidencia",
  },
  modals: {
    newOutput: "Nueva Salida de Retención",
  },
  filters: {
    month: "Mes",
    year: "Año",
    noOptions: "Sin opciones",
  },
  buttons: {
    save: "Guardar",
  },
  messages: {
    selectStation: "Selecciona una planta",
  },
};
